// src/services/defesaService.js

import api from './api';

// Lista TODAS as defesas (para usuários com acesso global, se necessário)
export const listarDefesas = async () => {
  return api.get('/defesas');
};

export const confirmarRealizacao = async (id) => {
  return api.post(`/defesas/${id}/confirmar-realizacao`);
};

// Obtém detalhes de uma defesa específica
export const obterDefesa = async (id) => {
  return api.get(`/defesas/${id}`);
};

// Cria nova defesa
export const criarDefesa = async (defesa) => {
  return api.post('/defesas', defesa);
};

// Atualiza uma defesa existente
export const atualizarDefesa = async (id, defesa) => {
  return api.put(`/defesas/${id}`, defesa);
};

// Exclui defesa
export const excluirDefesa = async (id) => {
  return api.delete(`/defesas/${id}`);
};

// Lista SOMENTE as defesas do avaliador logado (arguente, presidente ou supervisor)
export const listarDefesasDoAvaliador = async () => {
  return api.get('/defesas/avaliador');
};

const defesaService = {
  listarDefesas,
  obterDefesa,
  criarDefesa,
  atualizarDefesa,
  excluirDefesa,
  confirmarRealizacao,
  listarDefesasDoAvaliador
};

export default defesaService;
